import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import WP from 'WP';
import { setDateRange } from 'store';

import SkiFieldsInput from './SkiFieldsInput';
import DropdownList from './DropdownList';
import DatePicker from './DatePicker';
import TextArea from './TextArea';
import GridElement from 'partials/GridElement';
import InputPlus from 'icons/InputPlusIcon';

import Media from 'css/Media';

const numDays = [
    {label: "1", value: 1},
    {label: "2", value: 2},
    {label: "3", value: 3},
    {label: "4", value: 4},
    {label: "5", value: 5},
    {label: "6", value: 6},
    {label: "7", value: 7},
    {label: "8", value: 8},
    {label: "9", value: 9},
    {label: "10", value: 10},
    {label: WP.trans.moreThanTen, value: 11},
];
const skiLength = [
    {label: "167 cm", value: 167},
    {label: "177 cm", value: 177},
    {label: "197 cm", value: 197}
];
const shoeSize = [
    {label: "36", value: 36},
    {label: "37", value: 37},
    {label: "38", value: 38},
    {label: "39", value: 39},
    {label: "40", value: 40},
    {label: "41", value: 41},
    {label: "42", value: 42},
    {label: "43", value: 43},
    {label: "44", value: 44},
    {label: "45", value: 45},
    {label: WP.trans.otherSize, value: 11},
];

class SkiPackageOrderForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            addedProducts: [],
        };

        this.datePickr = React.createRef();
    }

    // Bogus validation before initiating handler
    handleDateChange(dateObj, dateStr, instance) {
        if(dateObj.length > 0) {
            this.props.setDate(dateObj);
        }
    }

    /**
     * Returns products in a Dropdown friendly format.
     * @returns {Array}
     */
    getProducts = () => {
        const { products } = this.props;

        return products.map(product => {
            return {
                label: product.acf.title,
                value: product
            };
        });
    };


    //Insert new product dropdown input
    addDropdownListItem = () => {
        const { addedProducts } = this.state;

        addedProducts.push(
            <SkiFieldsInput
                handleReservationsChange={this.props.handleAddReservations}
                products={this.getProducts()}
                handleSizeChange={(e, name) => this.handleSizeChange(e, name)}
                skiLength={skiLength}
                shoeSize={shoeSize}
                key={addedProducts.length + 1}
                idx={addedProducts.length + 1}
            />
        );

        this.setState({addedProducts: addedProducts});
    };

    render() {
        const {
            days,
            message,
            dateValid,
            defaultValue,
            handleAddReservations
        } = this.props;
        const { addedProducts } = this.state;

        return (
            <Wrapper id="ski_package_input">
                <FlexBox>
                    <SkiFieldsInput
                        defaultValue={defaultValue}
                        handleReservationsChange={handleAddReservations}
                        products={this.getProducts()}
                        handleSizeChange={(e, name) => this.handleSizeChange(e, name)}
                        skiLength={skiLength}
                        shoeSize={shoeSize}
                    />
                    { addedProducts.length > 0 && addedProducts.map(item => item)}
                    <AddInput onClick={() => this.addDropdownListItem()}>
                        <span><InputPlus /></span>
                        <p>{WP.trans.addPackage}</p>
                    </AddInput>
                </FlexBox>
            <FormGrid>
                <DatePickerGridElement
                    colStart={{default: 1, s: 1, m: 1}}
                    colEnd={{default: 8, s: 12, m: 6}}
                    rowStart={2}
                >
                    <DatePicker
                        dateHandler={(dateObjects, dateStr, instance) => this.handleDateChange(dateObjects, dateStr, instance)}
                        reference={this.datePickr}
                        valid={dateValid}
                    />
                </DatePickerGridElement>
                <DaysGridElement
                    colStart={{default: 1, s: 1, m: 7}}
                    colEnd={{default: 8, s: 12, m: 12}}
                    rowStart={{default: 3, m: 2}}
                >
                    <DropdownList 
                        name="days"
                        value={days + WP.trans.days}
                        onChange={e => this.props.setDropdownValue(e, 'days')}
                        handleBlur={this.handleBlur}
                        options={numDays}
                        label={WP.trans.numDays}
                    />
                </DaysGridElement>
                <GridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 4, m: 3}}
                >
                    <TextArea 
                        name="message"
                        onChange={e => this.props.handleTextAreaInputChange(e)}
                        label={WP.trans.messageToBooking}
                        value={message}
                    />
                </GridElement>
            </FormGrid>
            </Wrapper>
        )
    }
}

const actions = {
    setDateRange
};

export default connect(null, actions)(SkiPackageOrderForm);

const Wrapper = styled.div`
`

const FlexBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    ${Media.greaterThan('m')`
        flex-direction: row;
        justify-content: space-between;
    `}
`

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
    `}
`

const AddInput = styled.div`
    display: flex;
    align-items: flex-end;
    width: 47%;
    cursor: pointer;
    padding-bottom: 18px;
    margin-bottom: ${props => props.theme.spacing.contentXL};

    span {
        margin-right: ${props => props.theme.spacing.contentM};
    }

    &:hover {
        text-decoration: underline;
    }
    
    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const DatePickerGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const DaysGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`